<template>
  <div class="agricultural">
    <mynav></mynav>
    <div class="index-top">
      <img src="../assets/agriculturalTop.jpg" alt="" width="100%" />
      <div class="banner-text">
        <h1>智慧农业解决方案</h1>
        <p>
          平台累计成交项目3万余宗，成交额近100亿元，为农村发展、农业增产、农民增收提供了有效服务，架起了乡村振兴的又一座桥梁。
        </p>
        <div>立即咨询</div>
      </div>
    </div>
    <div class="general">
      <div class="item-title">农业平台应用</div>
      <div class="yingyong-content general-content">
        <div class="yingyong-content-left">
          <p>
            平台累计成交项目3万余宗，成交额近100亿元，为农村发展、农业增产、农民增收提供了有效服务，架起了乡村振兴的又一座桥梁。
          </p>
        </div>
        <div class="yingyong-content-right">
          <img src="../assets/yingyong.png" alt="" />
        </div>
      </div>
    </div>
    <div class="operating general">
      <div class="item-title">智慧农业运营赋能</div>
      <div class="operating-content general-content">
        <div class="operating-content-left">
          <p>
            以土流大数据为基础，结合测绘院GIS地理信息，将地、数、图关进行智能关联，实现地块、主体、历史信息的相互关联查询、精确统计覆盖率、覆盖范围，彻底解决模糊、重叠、遗漏的管理问题。
            实现以图管地，并逐步建立农村集体资产位置图、农业产业化及农业经营主体分布图、农村宅基地现状及利用地图等一系列专题应用图层。
            完成本市高标准农田上图入库工作，助力上海农业农村“一张图”建设。并为全国农田建设“一张图”提供基础。
          </p>
        </div>
        <div class="operating-content-right">
          <img src="../assets/chart.png" alt="" />
        </div>
      </div>
    </div>
    <div class="general">
      <div class="item-title">头部客户成功案例</div>
      <div class="case-content general-content">
        <div
          class="case-content-item"
          v-for="(item, index) in caseData"
          :key="index"
        >
          <img :src="item.img1" alt="" />
          <div class="case-content-item-bottom">
            <img :src="item.img2" alt="" />
            <div>
              <h4>{{ item.name }}</h4>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <myfooter :type="1"></myfooter> -->
  </div>
</template>
    <script>
// import myfooter from "../components/myfooter.vue";
import mynav from "../components/mynav.vue";
export default {
  data() {
    return {
      caseData: [
        {
          name: "上海农业要素交易所",
          text: "上海市公共资源交易平台全国第一",
          img1: require("../assets/cover3.jpg"),
          img2: require("../assets/coverLogo3.jpg"),
        },
      ],
    };
  },
  components: {
    // myfooter,
    mynav,
  },
};
</script>
<style lang="less" scoped>
.agricultural {
  .general {
    .yingyong-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .yingyong-content-left {
        width: 44%;
        line-height: 28px;
        font-size: 14px;
        color: rgba(73, 82, 103, 0.7);
      }
      .yingyong-content-right {
        width: 54%;
        img {
          width: 100%;
        }
      }
    }
  }
  .operating {
    background-color: #f5f7f9;
    padding-top: 40px;
    padding-bottom: 40px;
    .operating-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .operating-content-left {
        width: 54%;
        line-height: 28px;
        font-size: 14px;
        color: rgba(73, 82, 103, 0.7);
      }
      .operating-content-right {
        width: 43%;
        img {
          width: 100%;
        }
      }
    }
  }
  .general {
    .case-content {
      padding-bottom: 50px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .case-content-item {
        width: 300px;
        box-shadow: 0px 4px 14px rgba(75, 103, 136, 0.1);
        margin: 0 15px;
        img {
          width: 100%;
        }
        .case-content-item-bottom {
          display: flex;
          align-items: center;
          color: #21293e;
          padding: 10px 5px;
          box-sizing: border-box;
          img {
            width: 65px;
          }
          p {
            font-size: 10px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
}
@media screen and (max-width: 768px) {
  .agricultural {
    .general {
      .yingyong-content {
        display: block;
        width: 90%;
        .yingyong-content-left {
          width: 100%;
          // line-height: 30px;
        }
        .yingyong-content-right {
          width: 100%;
        }
      }
    }
    .operating {
      padding-top: 20px;
      padding-bottom: 20px;
      .operating-content {
        display: block;
        width: 90%;
        .operating-content-left {
          width: 100%;
        }
        .operating-content-right {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
    .general {
      .case-content {
        justify-content: space-between;
        .case-content-item {
          width: 48%;
          margin: 0 0 10px 0;
          .case-content-item-bottom {
            padding: 8px 3px;
            img {
              width: 40px;
            }
            h4 {
              font-size: 14px;
            }
            p {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}
</style>